import { render, staticRenderFns } from "./ImagesProgram.vue?vue&type=template&id=881df696&"
import script from "./ImagesProgram.vue?vue&type=script&lang=ts&"
export * from "./ImagesProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports